import React from 'react';
import { slabStylesByCategory } from '../../assets/externalSlabCatalogue';
import { withoutKnockerAndSpyhole } from '../../hardware/hardwareCompatibility';
import {
  type DoorConfiguration,
  type DoorHanding,
} from '../../types/doorConfiguration';
import { Button } from '../../ui/button';
import { Label } from '../../ui/label';

export const DoorStyleStage: React.FC<{
  configuration: DoorConfiguration;
  onChange: (next: DoorConfiguration) => void;
}> = ({ configuration, onChange }) => (
  <div className="flex flex-col gap-4">
    <div className="flex flex-col gap-2">
      <Label htmlFor="door-style">Door style</Label>
      <select
        id="door-style"
        aria-label="Door style"
        className="door-designer-select h-11 w-full rounded-md border border-solid border-border bg-card px-3 text-sm text-foreground"
        value={configuration.slab.styleId}
        onChange={(event) =>
          onChange({
            ...configuration,
            slab: { ...configuration.slab, styleId: event.target.value },
            hardware: withoutKnockerAndSpyhole(configuration.hardware),
          })
        }
      >
        {slabStylesByCategory().map((group) => (
          <optgroup key={group.categoryId} label={group.categoryLabel}>
            {group.styles.map((style) => (
              <option key={style.id} value={style.id}>
                {style.customerLabel}
              </option>
            ))}
          </optgroup>
        ))}
      </select>
    </div>

    <div>
      <p className="mb-2 text-xs font-semibold uppercase tracking-wide text-muted-foreground">
        Handing
      </p>
      <div role="radiogroup" aria-label="Handing" className="grid grid-cols-2 gap-2">
        {(['left', 'right'] as DoorHanding[]).map((handing) => {
          const selected = configuration.slab.handing === handing;
          return (
            <Button
              key={handing}
              type="button"
              role="radio"
              aria-checked={selected}
              variant={selected ? 'default' : 'outline'}
              onClick={() =>
                onChange({
                  ...configuration,
                  slab: { ...configuration.slab, handing },
                })
              }
            >
              {handing === 'left' ? 'Left' : 'Right'}
            </Button>
          );
        })}
      </div>
    </div>
  </div>
);
